module.exports = __webpack_public_path__ + "img/jy-xz.b30442d6.png";